import React from 'react';
import FormButton from '@app/component/form/button/FormButton';
import { InlineWidget, PopupButton } from 'react-calendly';
import Modal from '@app/component/overlays/modal/Modal';
import useModal from '@app/component/overlays/modal/ModalRef';


export const RatesPromotion = React.memo(() => {

	const calendlyUrl = "https://calendly.com/dionisis-roompulse/roompulse";

	const modal = useModal();

	return <main>
		<div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
			<div className="mt-8 sm:mt-12"><h2 className="text-base/7 font-semibold text-blue-600">Advanced Rate Shopping
				Suite</h2><p
				className="mt-0.5 max-w-lg text-pretty text-4xl font-semibold tracking-tight text-gray-950 sm:text-5xl">Make
				smarter pricing decisions</p>
				<div className="mt-10 grid grid-cols-1 gap-4 sm:mt-16 lg:grid-cols-6 lg:grid-rows-2">
					<div className="relative lg:col-span-3">
						<div className="absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem]"></div>
						<div
							className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)] lg:rounded-tl-[calc(2rem+1px)]">
							<img alt="Advanced Rate Shopping" src="/assets/img/product/rates/rates-calendar.jpg"
									 className="h-80 object-cover object-left-top" />
							<div className="p-10 pt-4"><h3 className="text-sm/4 font-semibold text-blue-600">Market Intelligence</h3>
								<p className="text-lg font-medium tracking-tight text-gray-950">Advanced Rate Shopping</p><p
									className="mt-2 max-w-lg text-sm/6 text-gray-600">Monitor real-time prices across multiple booking
									platforms to stay competitive. Quickly adjust your rates and stay ahead of the competition. Ensure you
									always offer the best rates to your customers.</p></div>
						</div>
						<div
							className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem]"></div>
					</div>
					<div className="relative lg:col-span-3">
						<div className="absolute inset-px rounded-lg bg-white lg:rounded-tr-[2rem]"></div>
						<div
							className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-tr-[calc(2rem+1px)]">
							<img alt="Flexisets" src="/assets/img/product/rates/flexisets.jpg"
									 className="h-80 object-cover object-left-top" />
							<div className="p-10 pt-4"><h3 className="text-sm/4 font-semibold text-blue-600">Upcoming Feature</h3><p
								className="text-lg font-medium tracking-tight text-gray-950">Flexisets</p><p
								className="mt-2 max-w-lg text-sm/6 text-gray-600">Build flexible sets of hotels, Airbnbs, or mixed
								portfolios to analyze price changes, occupancy patterns, and competitive performance. Unlock deeper
								market insights to optimize pricing strategies.</p></div>
						</div>
						<div
							className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 lg:rounded-tr-[2rem]"></div>
					</div>
					<div className="relative lg:col-span-2">
						<div className="absolute inset-px rounded-lg bg-white lg:rounded-bl-[2rem]"></div>
						<div
							className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-bl-[calc(2rem+1px)]">
							<img alt="Intelligent Alerts System" src="/assets/img/product/rates/alerts.jpg"
									 className="h-80 object-cover object-left-top" />
							<div className="p-10 pt-4"><h3 className="text-sm/4 font-semibold text-blue-600">Custom Alerts</h3><p
								className="text-lg font-medium tracking-tight text-gray-950">Intelligent Alerts System</p><p
								className="mt-2 max-w-lg text-sm/6 text-gray-600">Never miss a market shift. Get instant alerts so you
								can adjust your prices proactively.</p></div>
						</div>
						<div
							className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 lg:rounded-bl-[2rem]"></div>
					</div>
					<div className="relative lg:col-span-2">
						<div className="absolute inset-px rounded-lg bg-white"></div>
						<div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)]">
							<img alt="Integrations" src="/assets/img/product/rates/integrations.jpg"
									 className="h-80 object-cover object-center" />
							<div className="p-10 pt-4"><h3 className="text-sm/4 font-semibold text-blue-600">Integrations</h3><p
								className="text-lg font-medium tracking-tight text-gray-950">Price Recommendations &amp; Integration</p>
								<p className="mt-2 max-w-lg text-sm/6 text-gray-600">Receive smart price recommendations and seamlessly
									update rates through your Channel Manager or PMS.</p></div>
						</div>
						<div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5"></div>
					</div>
					<div className="relative lg:col-span-2">
						<div className="absolute inset-px rounded-lg bg-white max-lg:rounded-b-[2rem] lg:rounded-br-[2rem]"></div>
						<div
							className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-b-[calc(2rem+1px)] lg:rounded-br-[calc(2rem+1px)]">
							<img alt="Competitor Pace Analysis" src="/assets/img/product/rates/competitor-analysis.jpg"
									 className="h-80 object-cover object-left-top" />
							<div className="p-10 pt-4"><h3 className="text-sm/4 font-semibold text-blue-600">Analyze</h3><p
								className="text-lg font-medium tracking-tight text-gray-950">Competitor Pace Analysis</p><p
								className="mt-2 max-w-lg text-sm/6 text-gray-600">Understand booking trends by analyzing competitors'
								occupancy rates to make proactive decisions.</p></div>
						</div>
						<div
							className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-b-[2rem] lg:rounded-br-[2rem]"></div>
					</div>
				</div>
				<div className="px-6 pt-20 pb-8 sm:px-6 sm:pt-28 lg:px-8">
					<div className="mx-auto max-w-2xl text-center"><h2
						className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Maximize your
						revenue growth. Start using our app today.</h2><p
						className="mx-auto mt-6 max-w-xl text-pretty text-lg/6 text-gray-600">Learn more about how we can help you.
						Book a call with our team.</p>
						<div className="mt-10 flex items-center justify-center gap-x-6">
							<FormButton state="primary" extraClassName="sm:py-2.5 sm:px-12" onClick={() => modal.open()}>Book Now</FormButton>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Modal ref={modal.ref} width='4xlarge'>
			<InlineWidget url={calendlyUrl} />

		</Modal>
	</main>
})